import { AppState } from 'editor/src/store/app/types';

const setColorProfileLoadedReducer = (state: AppState) => {
  state.colorProfileLoaded = true;
};

export default setColorProfileLoadedReducer;
